import { FC } from 'react';
import styles from './fullscreenModal.module.css';
import leftArrow from '../../assets/left-arrow.png';
import { Trans } from 'react-i18next';
import { FullscreenModalProps } from './fullscreenModal.types';

const FullscreenModal: FC<FullscreenModalProps> = ({
  show,
  onBack,
  children,
  title,
  headerRight,
  modalStyle = '',
  headerStyle = '',
  contentStyle = '',
}) => {
  if (!show) return null;

  return (
    <div className={`${styles.modal} ${modalStyle}`}>
      <div className={`${styles.header} ${headerStyle}`}>
        <div className={styles.left}>
          <button onClick={onBack} className={styles.back} type="button">
            <img src={leftArrow} alt="Back" />
          </button>
          <div className={styles.title}>
            <Trans i18nKey={title} />
          </div>
        </div>
        <div className={styles.right}>{headerRight}</div>
      </div>
      <div className={`${styles.content} ${contentStyle}`}>{children}</div>
    </div>
  );
};

export default FullscreenModal;
